// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property, state } from 'lit/decorators.js';
import LightElement from './light-element.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { classMap } from 'lit/directives/class-map.js';

@customElement('product-viewer-open-button')
export default class ProductViewerOpenButton extends LightElement {

	@property({ type: String })
	productId: string;

	@property({ type: String })
	productDisplayName: string;

	@property({ type: String })
	text = "Choose Options";

	@property({ type: String })
	test = "product-viewer-open-button";

	@property({ type: String })
	extraCssClass: string;

	@property({ type: Boolean })
	showMessage: boolean;

	@property({ type: Boolean })
	isComparingMode: boolean;

	@property({ type: Function })
	buttonOnClick: (event) => void;

	private showProductViewer(event) {
		event.preventDefault();
		if (!document.querySelector('.atb__main--active')) {
			const isComparingModeAttr = this.isComparingMode ? 'isComparingMode' : '';
			document.body.insertAdjacentHTML('beforeend', `<product-viewer productId="${this.productId}" standalone ${isComparingModeAttr}></product-viewer>`);
		}
		if (this.buttonOnClick) {
			this.buttonOnClick(event);
		}
		
	}

	render() {
		return html`
			<button class="c-button c-button--full c-button--secondary c-add-product__button js-ignore-product-card-click ${classMap({ [this.extraCssClass]: this.extraCssClass })}" data-test="${this.test}" @click="${this.showProductViewer}" type="button"><span data-test="${this.test}-text">${this.text}</span> <span class="u-visuallyhidden">(opens ${this.productDisplayName} in an overlay)</span></button>
			${this.showMessage ? html`<product-viewer-open-button-message productId="${this.productId}"></product-viewer-open-button-message>` : nothing}
		`;
	}

}
